import React from 'react'
import { Route } from 'react-router-dom'
import { IndexTask, TasksCreate, TasksEdit, TasksMain, TasksView } from '../Views/Web/Tasks/Index'

function TaskRoutes() {
    return (
      <Route path="tasks" element={<TasksMain />}>
           <Route index element={<IndexTask/>} />
           <Route path='create' element={<TasksCreate/>} />
           <Route path='edit/:tasksEditId' element={<TasksEdit/>} />
           <Route path='view/:tasksViewId' element={<TasksView/>} />
      </Route>
    )
  }
  
  export default TaskRoutes